const $ = require('jquery');
window.$ = window.jQuery = $;

$.migrateMute = true;
$.migrateTrace = false;

// jQuery 4 removed these utilities — shim them for legacy plugins (chosen-js, jquery-datetimepicker, etc.)
$.trim = (str) => (str == null ? '' : String.prototype.trim.call(str));
$.isFunction = (fn) => typeof fn === 'function';
$.isArray = Array.isArray;
$.now = Date.now;
$.proxy = (fn, context, ...boundArgs) => {
    if (typeof fn !== 'function') {
        return undefined;
    }

    return function (...args) {
        return fn.apply(context || this, [...boundArgs, ...args]);
    };
};

import './bootstrap'

// Bootbox

import bootbox from 'bootbox';
window.bootbox = bootbox;

// Bootstrap Table

import { Modal as BsModal } from 'bootstrap';

window.bootstrap = {
    Modal: BsModal,
    Tooltip: {
        VERSION: "5"
    }
}

import('bootstrap-table');

// Chart.js

import chart from 'chart.js/auto';
window.Chart = chart;

// Chosen
require('chosen-js');

// Flatpickr

// import flatpickr from 'flatpickr';
// window.flatpickr = flatpickr;
window.flatpickr = require('flatpickr');

// jQuery UI - autocomplete
require('jquery-ui/ui/widgets/autocomplete.js');

// jQuery UI - sortable
require('jquery-ui/ui/widgets/sortable.js');

// Moment.js

const moment = require('moment');
window.moment = moment;

// Chart.js Moment Adapter (registers the moment date adapter on the bundled Chart instance)

require('chartjs-adapter-moment');

// Bootstrap Date Range Picker

const DateRangePicker = require('bootstrap-daterangepicker');

if (typeof $.fn.daterangepicker !== 'function') {
    $.fn.daterangepicker = function(options, callback) {
        const implementOptions = $.extend(true, {}, $.fn.daterangepicker.defaultOptions, options);

        this.each(function() {
            const el = $(this);

            if (el.data('daterangepicker')) {
                el.data('daterangepicker').remove();
            }

            el.data('daterangepicker', new DateRangePicker(el, implementOptions, callback));
        });

        return this;
    };
}

$.fn.daterangepicker.defaultOptions = $.fn.daterangepicker.defaultOptions || {};

// jQuery - Date Time Picker
require('jquery-datetimepicker');

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// Sprintf-js
window.sprintf = require('sprintf-js').sprintf;
window.vsprintf = require('sprintf-js').vsprintf;

// SweetAlert2

import sweetalert2 from 'sweetalert2';
window.Swal = sweetalert2;

// App

require('./app/theme.js');
require('./app/actions.js');
require('./app/can.js');
require('./app/chosen.js');
require('./app/colorCellStyle.js');
require('./app/datepicker.js');
require('./app/daterangepicker.js');
require('./app/i18n.js');
require('./app/nbrogress.js');
require('./app/online.js');
require('./app/password.js');
require('./app/ready.js');
require('./app/sidebar.js');
require('./app/tables.js');
require('./app/tabs.js');
require('./app/tooltip.js');
require('./app/validation.js');

// Cell Styles

require('./app/cellStyles/services/version/bugFixesEnd.js');
require('./app/cellStyles/services/version/laravel.js');
require('./app/cellStyles/services/version/php.js');
require('./app/cellStyles/services/version/securityFixesEnd.js');

// Formatters

// require('./app/formatters/color.js');
require('./app/formatters/aboutMe/detail.js');
require('./app/formatters/apis/logger/detail.js');
require('./app/formatters/apis/jorrt/requestDetail.js');
require('./app/formatters/apis/tuijncode/requestRowStyle.js');
require('./app/formatters/apis/monitoring/url.js');
require('./app/formatters/active.js');
require('./app/formatters/amountFooter.js');
require('./app/formatters/avatar.js');
require('./app/formatters/boolean.js');
require('./app/formatters/toggleable.js');
require('./app/formatters/moduleName.js');
require('./app/formatters/note/copy.js');
require('./app/formatters/note/detail.js');
require('./app/formatters/showBackground.js');
require('./app/formatters/showTitle.js');
require('./app/formatters/pageShowTitle.js');
require('./app/formatters/pageShowDescription.js');
require('./app/formatters/portfolio/visible.js');
require('./app/formatters/portfolio/category/visible.js');
require('./app/formatters/cdn/adminDestroy.js');
require('./app/formatters/customer/website.js');
require('./app/formatters/cdn/adminName.js');
require('./app/formatters/cdn/edit.js');
require('./app/formatters/cdn/thumbnail.js');
require('./app/formatters/country/icon.js');
require('./app/formatters/cdnDestroy.js');
require('./app/formatters/cdnIcon.js');
require('./app/formatters/cdnName.js');
require('./app/formatters/cdnType.js');
require('./app/formatters/cdnUrl.js');
require('./app/formatters/contactForm/detail.js');
require('./app/formatters/contactForm/status.js');
require('./app/formatters/curriculumVitae/detail.js');
require('./app/formatters/curriculumVitae/item/detail.js');
require('./app/formatters/customer.js');
require('./app/formatters/delete.js');
require('./app/formatters/domain/environment.js');
require('./app/formatters/domain/blog/hits.js');
require('./app/formatters/domain/employee/detail.js');
require('./app/formatters/domain/footer/type.js');
require('./app/formatters/domain/pageDetail.js');
require('./app/formatters/domain/statistics/detail.js');
require('./app/formatters/domain/solution/type.js');
require('./app/formatters/duplicate.js');
require('./app/formatters/edit.js');
require('./app/formatters/export/backup/download.js');
require('./app/formatters/export/timesheet/download.js');
require('./app/formatters/export/version/download.js');
require('./app/formatters/faq/detail.js');
require('./app/formatters/monitoring/environment.js');
require('./app/formatters/monitoring/icon.js');
require('./app/formatters/monitoring/online.js');
require('./app/formatters/monitoring/event/data.js');
require('./app/formatters/monitoring/request/csence.js');
require('./app/formatters/monitoring/request/how.js');
require('./app/formatters/monitoring/request/detail.js');
require('./app/formatters/notification/details.js')
require('./app/formatters/notification/message.js');
require('./app/formatters/notification/rowStyle.js');
require('./app/formatters/notification/type.js');
require('./app/formatters/option.js');
require('./app/formatters/fontAwesome.js');
require('./app/formatters/generalLedgerAccount.js');
require('./app/formatters/loginAs.js');
require('./app/formatters/project.js');
require('./app/formatters/project/detail.js');
require('./app/formatters/project/row/detail.js');
require('./app/formatters/project/row/priority.js');
require('./app/formatters/project/row/type.js');
require('./app/formatters/purchase/invoice/detail.js');
require('./app/formatters/purchase/invoice/download.js');
require('./app/formatters/rowStyle.js');
require('./app/formatters/profitAndLoss/reference.js');
require('./app/formatters/sales/invoice/creditedBy.js');
require('./app/formatters/sales/invoice/creditedFor.js');
require('./app/formatters/sales/invoice/detail.js');
require('./app/formatters/sales/invoice/download.js');
require('./app/formatters/services/version/counter.js');
require('./app/formatters/services/webapplication/detail.js');
require('./app/formatters/solution/cms/module/detail.js');
require('./app/formatters/task.js');
require('./app/formatters/task/detail.js');
require('./app/formatters/task/priority.js');
require('./app/formatters/task/reference.js');
require('./app/formatters/task/time/diffFormatter.js');
require('./app/formatters/thumbnails/resizing.js');
require('./app/formatters/show.js');
require('./app/formatters/sortable.js');
require('./app/formatters/supplier.js');
require('./app/formatters/tags.js');
require('./app/formatters/testimonial/detail.js');
require('./app/formatters/timesheet/reference.js');
require('./app/formatters/tuijncode/export/backup/download.js');
require('./app/formatters/tuijncode/export/timesheet/download.js');
require('./app/formatters/tuijncode/export/version/download.js');
require('./app/formatters/tuijncode/invoice/detail.js');
require('./app/formatters/tuijncode/invoice/download.js');
require('./app/formatters/versions/refresh.js');
require('./app/formatters/versions/environment.js');
require('./app/formatters/url.js');

// Functions

require('./app/functions/is_empty.js');
require('./app/functions/number_format_to_decimal.js');
require('./app/functions/number_format.js');
